import { useMemo } from 'react';
import cn from 'clsx';
import { Tooltip } from '@crehana/compass.ui';
import { jsx as _jsx } from "react/jsx-runtime";
var MINIMUM_TEXT_LENGTH_TO_RENDER_TOOLTIP = 86;
var PlayroomBadgeCardDescription = function PlayroomBadgeCardDescription(_ref) {
  var text = _ref.text,
    completed = _ref.completed;
  var paragraphTextElement = useMemo(function () {
    return /*#__PURE__*/_jsx("p", {
      className: cn('tw-font-body4 dark:tw-text-neutral-light-100 tw-line-clamp-2', !completed && 'tw-mb-1.2'),
      children: text
    });
  }, [completed, text]);
  var shouldRenderTooltip = text.length > MINIMUM_TEXT_LENGTH_TO_RENDER_TOOLTIP;
  if (shouldRenderTooltip) {
    return /*#__PURE__*/_jsx(Tooltip, {
      label: text,
      type: "small",
      children: paragraphTextElement
    });
  }
  return paragraphTextElement;
};
export default PlayroomBadgeCardDescription;